import configData from '../../config.json';
import httpClient from './httpClient';

export async function fetchProductImageUrl(token, rmcCode) {
  const response = await httpClient.get('/GetImageURL', {
    token,
    query: {
      rmcCode,
      'subscription-key': configData.subscriptionkey,
    },
    headers: {
      'X-Brand': 'TUDOR',
      'X-CardType': 'ServiceCard',
    },
    responseType: 'json',
  });

  return response.data;
}
